import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { TexttemplateModel } from 'projects/core/src/lib/models/texttemplate.model';
import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { forkJoin } from 'rxjs';
import { LanguageModel } from 'projects/core/src/lib/models/language.model';
import { HelperService } from 'projects/admin/src/app/services/helper.service';

@Component({
  selector: 'app-texttemplate-detail',
  templateUrl: './texttemplate-detail.component.html',
  styleUrls: ['./texttemplate-detail.component.scss']
})
export class TexttemplateDetailComponent extends BaseDetail implements OnInit {

  public texttemplate: TexttemplateModel = null;
  public languages: Array<LanguageModel> = [];

  public backRoute = ['/contents/texttemplates'];
  protected identifier = 'texttemplate';

  constructor(
    protected ui: UiService,
    protected router: Router,
    private api: ApiService,
    private route: ActivatedRoute,
    protected helper: HelperService,
    public transloco: TranslocoService
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.id === 'new') {
        this.setInitialized(DetailModes.new);
      } else if (params.id) {
        this.setLoading();
        forkJoin([
          this.api.getModel('texttemplates', params.id),
          this.api.getModels('languages'),
        ]).subscribe({
          next: (result: any) => {
            if (result[0].data) {
              this.texttemplate = new TexttemplateModel().deserialize(result[0].data);
            }
            if (result[1].data) {
              this.languages = result[1].data.map((language: any) => {
                return new LanguageModel().deserialize(language);
              });
            }
            this.tabIndex = parseInt(localStorage.getItem(this.identifier + '-tab'), 10);
            this.setInitialized(DetailModes.edit);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      } else {
        this.onClose();
      }
    });
  }

}
